import {
  ActivatedRouteSnapshot,
  BaseRouteReuseStrategy,
} from '@angular/router';

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
  // eslint-disable-next-line class-methods-use-this
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot,
  ): boolean {
    if (future.data['shouldReuse'] === undefined) {
      return super.shouldReuseRoute(future, curr);
    }

    return future.data['shouldReuse'] || false;
  }
}
